import src from "IMAGE";
export default { src, width: 28, height: 28, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
